<!-- お知らせ一覧 -->
<template>
  <div class="crpg-o-news-list">
    <ul v-if="completedLoad && item_list.length > 0">
      <li v-for="item in item_list" :key="item.id" @click="showDetail(item.id)">
        <div class="date">
          {{ item.pub_date.replace(/-/g, ".").slice(0, -15) }}
        </div>
        <div class="title">
          {{ item.display_title }}
        </div>
      </li>
    </ul>
    <div v-else-if="completedLoad">
      <p class="no-news">該当するお知らせはありません。</p>
    </div>
  </div>
</template>

<script>
import { getActiveSubDirectory } from "@/utils/subDirectoryUtils.js";

export default {
  name: "CrpgOrganismsNewsList",
  components: {},
  props: {
    /**
     * TOPページで表示の場合は本コンポーネント独自のタイトルは非表示にする
     */
    maxNumOfDisplay: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    // お知らせ取得
    this.getNews();
  },
  computed: {
    newsDetailLink() {
      const activeSubDirectory = getActiveSubDirectory(this.$route.path);
      console.log(activeSubDirectory);
      // アクティブなサブディレクトリが見つかった場合は、そのサブディレクトリに基づいたリンクを返す
      return activeSubDirectory ? `${activeSubDirectory}/news-detail` : "/news-detail";
    }
  },
  data() {
    return {
      item_list: [],
      completedLoad: false,
    };
  },
  methods: {
    showDetail(id) {
    this.$router.push(this.newsDetailLink + "/" + id);
  },
    getNews() {
      this.item_list = [];
      this.completedLoad = false;
      this.$repositories("cms")
        .getNews()
        .then((res) => {
          this.dataMaker(res);
          this.controlPagination = res.data.links;
        })
        .catch((err) => {
          console.log("CMS:お知らせ一覧取得エラー", err);
        })
        .finally(() => {
          this.completedLoad = true;
        });
    },
    dataMaker(obj) {
      const lists = obj.data.data;
      const newsTypeNames = obj.data.included;
      // 最大表示件数の指定があればその数だけリストに入れる
      if (lists != null) {
        let max = lists.length;
        if (this.maxNumOfDisplay && max > this.maxNumOfDisplay) {
          max = this.maxNumOfDisplay;
        }
        for (let i = 0; i < max; i++) {
          let item = lists[i];
          const newsTypeName = newsTypeNames.find(
            (el) => el.id === item.relationships.news_type.data.id
          );
          this.item_list.push({
            pub_date: item.attributes.pub_date,
            news_type_name: newsTypeName.attributes.name,
            display_title: item.attributes.display_title,
            id: item.id,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/news/list.scss";
</style>
